import { Box, Divider, Modal, Typography } from '@mui/material';
import { isEmpty } from 'lodash';
import React from 'react';
import Button from '../../../components/Button';
import { addDoctorApi, updateDoctorApi, addUserDoctorContact, updateUserDoctorContact } from '../../../utils/api';
import { useMutation } from 'react-query';
import useStore from '../../../Store/Store';
import TextInput from '../../../components/TextInput';
import PhoneInput from '../../../components/PhoneInput';
import { useTheme } from '@mui/material/styles';
import { useMediaQuery } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useUserLocation } from '../../../hooks/useUserLocation';

const AddDoctorModal = ({ show, onClose, recipient, refetch, activeEditData }) => {
  const { t } = useTranslation();
  const user = useStore((state) => state.user);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const { country } = useUserLocation();
  const [state, setState] = React.useState({
    name: '',
    phone: '',
    clinic: '',
    address: '',
    availability: '',
    errorMessage: '',
  });

  React.useEffect(() => {
    if (!isEmpty(activeEditData)) {
      setState((prev) => {
        return {
          ...prev,
          name: activeEditData.name,
          phone: activeEditData.phoneNo,
          clinic: activeEditData.clinic,
          address: activeEditData.address,
          availability: activeEditData.availability,
        };
      });
    }
  }, [activeEditData]);

  const addDoctorHandler = useMutation(recipient?._id ? addDoctorApi : addUserDoctorContact, {
    onSuccess: async ({ data }) => {
      setState({
        name: '',
        phone: '',
        clinic: '',
        address: '',
        availability: '',
        errorMessage: '',
      });
      refetch();
      onClose();
    },
    onError: (error) => {
      console.log('error =====> ', error);
      setState((prev) => {
        return { ...prev, errorMessage: error?.response?.data?.message || 'Something went wrong!' };
      });
    },
  });

  const updateDoctorHanlder = useMutation(recipient?._id ? updateDoctorApi : updateUserDoctorContact, {
    onSuccess: async ({ data }) => {
      setState({
        name: '',
        phone: '',
        clinic: '',
        address: '',
        availability: '',
        errorMessage: '',
      });
      refetch();
      onClose();
    },
    onError: (error) => {
      console.log('error =====> ', error);
      setState((prev) => {
        return { ...prev, errorMessage: error?.response?.data?.message || 'Something went wrong!' };
      });
    },
  });

  const handleSubmit = (e) => {
    e.preventDefault();

    const { name, phone, clinic, address, availability } = state;

    if (isEmpty(name) || isEmpty(phone) || isEmpty(clinic) || isEmpty(address) || isEmpty(availability)) {
      setState((prev) => {
        return { ...prev, errorMessage: 'Fill all the fields' };
      });
      return;
    }

    const body = {
      name,
      phone,
      clinic,
      address,
      availability,
    };

    if (!isEmpty(activeEditData)) {
      updateDoctorHanlder.mutate({
        userId: user?._id,
        recipientId: recipient?._id,
        doctorId: activeEditData?._id,
        body,
      });
    } else {
      if (recipient?._id) {
        addDoctorHandler.mutate({ userId: user?._id, recipientId: recipient?._id, body });
      } else {
        addDoctorHandler.mutate({ userId: user?._id, body });
      }
    }
  };

  const onCloseModal = () => {
    setState({
      name: '',
      phone: '',
      clinic: '',
      address: '',
      availability: '',
      errorMessage: '',
    });
    onClose();
  };

  return (
    <Modal
      open={show}
      onClose={onCloseModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          width: isMobile ? '70%' : '30%',
          p: isMobile ? 3 : 6,
          bgcolor: 'background.paper',
          borderRadius: 2.5,
          // position: 'relative',
          // top: 50,
          // left: isMobile ? '5%' : '35%',
        }}
      >
        <Typography variant="h5" textAlign="center" marginBottom={'20px'}>
          {t('addDoctorContact')}
        </Typography>
        <TextInput
          label={t('name')}
          value={state.name}
          onChange={(e) =>
            setState((prev) => {
              return {
                ...prev,
                name: e.target.value,
              };
            })
          }
        />

        <PhoneInput
          placeholder={t('enterDoctorContact')}
          defaultCountry={country}
          value={state.phone}
          onChange={(value) =>
            setState((prev) => {
              return { ...prev, phone: value };
            })
          }
        />

        <TextInput
          label={t('clinic')}
          value={state.clinic}
          onChange={(e) =>
            setState((prev) => {
              return {
                ...prev,
                clinic: e.target.value,
              };
            })
          }
        />

        <TextInput
          label={t('address')}
          value={state.address}
          onChange={(e) =>
            setState((prev) => {
              return {
                ...prev,
                address: e.target.value,
              };
            })
          }
        />

        <TextInput
          label={t('availability')}
          value={state.availability}
          onChange={(e) =>
            setState((prev) => {
              return {
                ...prev,
                availability: e.target.value,
              };
            })
          }
        />

        <Typography variant="subtitle1" style={{ color: 'red', marginTop: '30px' }} textAlign="center">
          {state.errorMessage && t(state.errorMessage)}
        </Typography>

        <Divider
          sx={{
            marginTop: 2,
            borderColor: '#E0E0E0',
          }}
        />

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            paddingTop: 2,
          }}
        >
          <Button text={t('cancel')} onClick={onCloseModal} bg="light" />
          <Button text={t('submit')} onClick={handleSubmit} loading={addDoctorHandler.isLoading} />
        </Box>
      </Box>
    </Modal>
  );
};

export default AddDoctorModal;
